export const APP_NAME = 'Leviathan BI'

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  OWNER: 'owner',
  ANALYST: 'analyst',
  VIEWER: 'viewer',
} as const

export type Role = (typeof ROLES)[keyof typeof ROLES]

export const PERMISSIONS = {
  // Dashboard - all roles
  DASHBOARD_VIEW: ['viewer', 'analyst', 'owner', 'super_admin'],

  // Analytics
  ANALYTICS_VIEW: ['viewer', 'analyst', 'owner', 'super_admin'],
  ANALYTICS_EXPORT: ['analyst', 'owner', 'super_admin'],
  ANALYTICS_QUERY: ['analyst', 'owner', 'super_admin'],

  // Users
  USERS_VIEW: ['analyst', 'owner', 'super_admin'],
  USERS_MANAGE: ['owner', 'super_admin'],

  // Connectors
  CONNECTORS_VIEW: ['analyst', 'owner', 'super_admin'],
  CONNECTORS_MANAGE: ['owner', 'super_admin'],

  // Jobs
  JOBS_VIEW: ['analyst', 'owner', 'super_admin'],
  JOBS_MANAGE: ['owner', 'super_admin'],

  // Settings
  SETTINGS_VIEW: ['owner', 'super_admin'],
  SETTINGS_MANAGE: ['owner', 'super_admin'],

  // Super Admin only
  TENANTS_MANAGE: ['super_admin'],

  // Platform-level super_admin permissions (god mode).
  // See plan Fase 0.2. These MUST remain exclusive to super_admin —
  // owner of a tenant never gets them, not even for their own tenant,
  // because they cross tenant boundaries or touch platform metadata.
  PLATFORM_TENANTS_READ: ['super_admin'],
  PLATFORM_TENANTS_CREATE: ['super_admin'],
  PLATFORM_TENANTS_UPDATE: ['super_admin'],
  PLATFORM_TENANTS_SUSPEND: ['super_admin'],
  PLATFORM_TENANTS_DELETE: ['super_admin'],
  PLATFORM_MIGRATIONS_READ: ['super_admin'],
  PLATFORM_MIGRATIONS_PLAN: ['super_admin'],
  PLATFORM_MIGRATIONS_EXECUTE: ['super_admin'],
  PLATFORM_MIGRATIONS_REVERT: ['super_admin'],
  PLATFORM_AUDIT_READ: ['super_admin'],
  PLATFORM_IMPERSONATE: ['super_admin'],
  PLATFORM_PLANS_WRITE: ['super_admin'],
} as const

export type Permission = keyof typeof PERMISSIONS

export const DATE_FORMATS = {
  SHORT: 'DD/MM/YYYY',
  LONG: 'D MMMM YYYY',
  WITH_TIME: 'DD/MM/YYYY HH:mm',
  ISO: 'YYYY-MM-DD',
} as const

export const DEFAULT_CURRENCY = 'EUR'
export const DEFAULT_LOCALE = 'it'
